// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureDetailActions_container__1Ku_p"};